import { Component, Input, OnInit } from '@angular/core';
import { formatISO } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import {
    CustomerDetailsCourseParticipation,
    TimeExpenditure,
} from '../../../../../../../shared/interfaces/src';
import { CustomerService } from '../../services/customer.service';
import * as _ from 'lodash';

@Component({
    selector: 'cna-customer-reading-times',
    templateUrl: './customer-reading-times.component.html',
    styleUrls: ['./customer-reading-times.component.scss'],
})
export class CustomerReadingTimesComponent implements OnInit {
    @Input()
    courseParticipations: CustomerDetailsCourseParticipation[];

    constructor(private readonly customerService: CustomerService) {}

    timeExpenditures$: Observable<
        {
            courseParticipation: CustomerDetailsCourseParticipation;
            timeExpenditures: TimeExpenditure[];
            months: {
                month: Date;
                timeExpenditures: { duration: number; date: Date }[];
                duration: number;
            }[];
            examinableTimeExpenditures: {
                faoTitle: string;
                timeExpenditures: { duration: number; date: Date }[];
                duration: number;
            }[];
            duration: number;
        }[]
    >;

    protected readonly takeUntil = takeUntil;

    ngOnInit(): void {
        this.timeExpenditures$ = this.customerService
            .getTimeExpenditure(this.courseParticipations?.map(c => c.id) ?? [])
            .pipe(
                map(timeExpenditures =>
                    _.map(
                        _.map(
                            _.map(
                                _.groupBy(
                                    _.map(timeExpenditures, te => ({
                                        ...te,
                                        date: formatISO(
                                            utcToZonedTime(
                                                te.lastRead,
                                                'Europe/Berlin'
                                            ),
                                            { representation: 'date' }
                                        ),
                                        month: formatISO(
                                            utcToZonedTime(
                                                te.lastRead,
                                                'Europe/Berlin'
                                            ),
                                            { representation: 'date' }
                                        ).substr(0, 7),
                                    })),
                                    'courseParticipationId'
                                ),
                                (
                                    timeExpendituresDir,
                                    courseParticipationId
                                ) => ({
                                    courseParticipation:
                                        this.courseParticipations.find(
                                            cp =>
                                                cp.id === courseParticipationId
                                        ),
                                    timeExpenditures: timeExpenditures.filter(
                                        tE =>
                                            tE.courseParticipationId ===
                                            courseParticipationId
                                    ),
                                    months: _.sortBy(
                                        _.map(
                                            _.groupBy(
                                                timeExpendituresDir,
                                                'month'
                                            ),
                                            (monthsDir, month) => ({
                                                month: new Date(month),
                                                timeExpenditures: _.sortBy(
                                                    _.map(
                                                        _.groupBy(
                                                            monthsDir,
                                                            'date'
                                                        ),
                                                        (value, date) => ({
                                                            duration: _.reduce(
                                                                value,
                                                                (sum, te) =>
                                                                    (sum +=
                                                                        te.duration),
                                                                0
                                                            ),
                                                            date: new Date(
                                                                date
                                                            ),
                                                        })
                                                    ),
                                                    'date'
                                                ),
                                            })
                                        ),
                                        'month'
                                    ),
                                    examinableTimeExpenditures: [],
                                })
                            ),
                            item => ({
                                ...item,
                                months: _.map(item.months, month => ({
                                    ...month,
                                    duration: _.reduce(
                                        month.timeExpenditures,
                                        (sum, te) => (sum += te.duration),
                                        0
                                    ),
                                })),
                                examinableTimeExpenditures: [],
                            })
                        ),
                        item => ({
                            ...item,
                            duration: _.reduce(
                                item.months,
                                (sum, month) => (sum += month.duration),
                                0
                            ),
                        })
                    )
                )
            );
    }
}
